// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"CommBody_toolbar__CjGhH","body":"CommBody_body__34Q6I","rte":"CommBody_rte__LzoCy","variablesRoot":"CommBody_variablesRoot__1cxBr"};